'use strict';

  var $carousel = $('.js-hero-carousel'),
      $carouselContent,
      $carouselBelt,
    	$carouselSlides,

    	$carouselArrowRight,
    	$carouselArrowLeft,
    	$counterState,
    	$counterLength,
      $carouselBG,
      $carouselBGSlides,
      $readMoreButton,
      slideIndex,
      currentIndex,
      slideLength,
      fadeTiming,
      fadeDelay,
      isAnimating;

  if (!$carousel.length) return;

  $carouselContent = $carousel.find('.js-hero-carousel-body');
  $carouselSlides  = $carousel.find('.js-hero-carousel-slide');
  $carouselBelt =  $carousel.find('.js-hero-carousel-belt');
  $carouselArrowLeft  = $carousel.find('.js-slide-carousel-left');
  $carouselArrowRight  = $carousel.find('.js-slide-carousel-right');
  $readMoreButton=$carousel.find('.js-hero-carousel-readmore');
  //Always starts at 0
  slideIndex = 0;
  slideLength  = $carouselSlides.length - 1;

  $carouselBG = $('.js-slick-background');
  $carouselBGSlides = $carouselBG.find('.js-hero-intro-item');

  $counterState = $carousel.find('.js-counter-state');
  $counterLength = $carousel.find('.js-counter-length');

  fadeTiming = 500;
  fadeDelay = 0;


  function animateSlide(direction) {
    if (isAnimating) return;

    isAnimating = true;

    currentIndex = slideIndex;

    (direction ==='forward') ? ++slideIndex : --slideIndex;

    //check for out of bounds
    if (slideIndex > slideLength) slideIndex = 0;
    if (slideIndex < 0) slideIndex = slideLength;
      var $currentSlide = $carouselSlides.eq(currentIndex);
      var $nextSlide = $carouselSlides.eq(slideIndex);
      
      if (!isImageInDom(slideIndex)) {
          putImageInDomViaAjax(currentIndex, slideIndex, function() {
              handleAnimation($currentSlide, $nextSlide);
          });
      } else {
          handleAnimation($currentSlide, $nextSlide);
      }
  }

  function isImageInDom(indexToGetImageFor) {
      //Get the slide that we need the image for
      var slideToUpdate = $carouselSlides.eq(indexToGetImageFor);
      var elementIdOfSlideToUpdate = slideToUpdate.data('elementid');
      var elementOfMatchedBackgroundImage = $carouselBGSlides.filter("[data-elementid='" + elementIdOfSlideToUpdate + "']");
      if (elementOfMatchedBackgroundImage.length > 0) {
          return true;
      }

      return false;
  }

  function putImageInDomViaAjax(currentIndex, indexOfCollection, callback) {
      $.ajax({
          url: '/api/sitecore/home/GetCarouselImage?skip=' + indexOfCollection,
          success: function(data) {
              var elementToAdd = $(data);
              elementToAdd.attr('data-index', indexOfCollection);
              if (elementToAdd.length > 0) {
                  elementToAdd.insertAfter($carouselBGSlides.filter("[data-index='" + currentIndex + "']"));
                  $carouselBGSlides = $carouselBG.find('.js-hero-intro-item');   
              }              
              callback();
          }
      });      
  }


  function handleAnimation($currentNode, $nextNode) {

    $carouselContent.velocity( "fadeOut", {
            duration: fadeTiming,
            complete: function(elements) { 
              $currentNode.removeClass('is-activated');
              $nextNode.addClass('is-activated');

              //update count state
              $counterState.text(slideIndex + 1);

                //update link
              var readMoreHref = $nextNode.find(".hero-carousel__link").attr('href');
              $readMoreButton.attr('href', readMoreHref);
              if (readMoreHref != '' && readMoreHref != '#') {
                  $readMoreButton.show();                
              } else {
                  $readMoreButton.hide();
              }
            }
      })
    .velocity( "fadeIn", {
         duration: fadeTiming
         
    });

  

    $carouselBGSlides.filter("[data-index='" + currentIndex + "']")
      .velocity( "fadeOut", {
        duration: 1000
    });

      $carouselBGSlides.filter("[data-index='" + slideIndex + "']")
      .velocity( "fadeIn", {
        duration: 300,
        complete: function(elements) { 
            $carouselBGSlides.filter("[data-index='" + currentIndex + "']").removeClass('.is-active');                
            $carouselBGSlides.filter("[data-index='" + slideIndex + "']").addClass('.is-active');
            
            
            
        }
    });

      //show and update href of readmore
     
    isAnimating = false;
  }


  $carouselArrowRight.on('click.heroCarousel', function(ev) {
    ev.preventDefault();


    animateSlide('forward');
  });

  $carouselArrowLeft.on('click.heroCarousel', function(ev) {
    ev.preventDefault();


    animateSlide('backward');
  });

  var hammer = new Hammer($carouselContent[0]);

  hammer.on('swipeleft', function(ev){
//
    animateSlide('forward');
  });

  hammer.on('swiperight', function(ev){
//
    animateSlide('backward');
  });